import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const me = await api.getMe();
      setUser(me);
    } catch (_) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const acceptTerms = async () => {
    const me = await api.acceptTerms();
    setUser(me);
    return me;
  };

  const googleLogin = async (credential) => {
    const me = await api.googleVerify(credential);
    setUser(me);
    return me;
  };

  const logout = async () => {
    try { await api.logout(); } catch (_) { /* ignore */ }
    setUser(null);
    window.location.href = "/login";
  };

  const value = {
    user, loading, setUser, checkAuth, acceptTerms, googleLogin, logout,
    isOwner: user?.role === "OWNER",
    isAdmin: user?.role === "ADMIN" || user?.role === "OWNER",
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
